import { render, staticRenderFns } from "./UserPictures.vue?vue&type=template&id=8d5ec64c&scoped=true&"
import script from "./UserPictures.vue?vue&type=script&lang=ts&"
export * from "./UserPictures.vue?vue&type=script&lang=ts&"
import style0 from "./UserPictures.vue?vue&type=style&index=0&id=8d5ec64c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5ec64c",
  null
  
)

export default component.exports